/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-11 15:10:03
 * @LastEditTime: 2022-01-11 16:48:40
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 银联对账单 - 汇总数据订单明细数据
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/YLPayOrderSummaryList/components/YlPayOrderSummaryDataOrderList.jsx
 */
import React from 'react'
import TableHelper from '../../../../components/TableHelper'
import { fetchPlatformRecordYlPayOrderSummaryDataOrderInfoPage } from '../../../../services/platformAccountingRecord'
import { formatTime } from '../../../../utils'
import YlPayOrderSummaryDataOrderDetail from './YlPayOrderSummaryDataOrderDetailModal'

const YlPayOrderSummaryDataOrderList = (props) => {
    let YlPayOrderSummaryDataOrderDetailRef = null
    const columns = [
        { title: '交易日期时间', dataIndex: 'tradeDateTime', width: 140, render: (text) => formatTime(text)},
        { title: '商户名称', dataIndex: 'merchantName', width: 140},
        { title: '商户号', dataIndex: 'merchantNumber', width: 140},
        { title: '终端号', dataIndex: 'terminalNumber', width: 120},
        { title: '交易金额(元)', dataIndex: 'tradeAmount', width: 90},
        { title: '手续费(元)', dataIndex: 'serviceCharge', width: 90},
        { title: '清算金额(元)', dataIndex: 'liquidationAmount', width: 90},
        { title: '银商订单号', dataIndex: 'silverMerchantOrderNo', width: 140},
        { title: '第三方订单号', dataIndex: 'thirdPartyOrderNo', width: 140},
        { title: '流水号', dataIndex: 'serialNumber', width: 140},
        { title: '参考号', dataIndex: 'referenceNumber', width: 140},
        { title: '分店简称', dataIndex: 'branchStore', width: 220},
        { title: '卡类型', dataIndex: 'cardType', width: 100},
        { title: '子订单号', dataIndex: 'childOrderNo', width: 140},
        { title: '实际支付金额', dataIndex: 'actualPaymentAmount', width: 140},
        { title: '创建时间', dataIndex: 'createTime',width: 140, render: (text) => formatTime(text)},
        { title: '发卡行', dataIndex: 'issuingBank', width: 140},
        { title: '商户优惠金额', dataIndex: 'merchantDiscountAmount', width: 140},
        { title: '商户订单号', dataIndex: 'merchantOrderNo', width: 140},
        { title: '其他优惠金额', dataIndex: 'otherDiscountAmount', width: 140},
        { title: '支付类型', dataIndex: 'payType', width: 140},
        { title: '付款附言', dataIndex: 'postscriptPayment', width: 140},
        { title: '备注信息', dataIndex: 'remark', width: 140},
        { title: '退货订单号', dataIndex: 'returnGoodsOrderNo', width: 140},
        // { title: '分期付息方', dataIndex: 'stagesInterestPayer', width: 140},
        // { title: '分期期数', dataIndex: 'stagesNumber', width: 140},
        // { title: '分期手续费', dataIndex: 'stagesServiceCharge', width: 140},
        // { title: '分期服务方', dataIndex: 'stagesServiceParty', width: 140},
        { title: '交易卡号', dataIndex: 'tradeCardNumber', width: 140},
        { title: '交易日期', dataIndex: 'tradeDate', width: 140},
        { title: '交易时间', dataIndex: 'tradeTime', width: 140},
        { title: '交易类型', dataIndex: 'tradeType', width: 140},
        { title: '钱包优惠金额', dataIndex: 'walletDiscountAmount', width: 140},
        { title: '详情', dataIndex: 'action',width: 70 , fixed: 'right', render: (text,record) =>{
            return <a onClick={() =>YlPayOrderSummaryDataOrderDetailRef.open(record.id)}>详情</a>
        }}
    ]
    const parseRequestData = (data) => {
        data.summaryDataId = props.id
        return data
    }
    return (
        <div>
            {props.id && (
                <TableHelper columns={columns} parseRequestData={parseRequestData} scroll={{x: 3000}} request={fetchPlatformRecordYlPayOrderSummaryDataOrderInfoPage} />
            )}
            <YlPayOrderSummaryDataOrderDetail getRef={ref => YlPayOrderSummaryDataOrderDetailRef = ref} />
        </div>
    )
}

export default YlPayOrderSummaryDataOrderList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLPayOrderSummaryList/components/YlPayOrderSummaryDataOrderList.jsx